module.exports = __webpack_public_path__ + "static/media/1012819.766ac445.png";